import styled, { keyframes } from "styled-components";
import { IconProps } from "./types";

export const LoadingIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <StyledSvg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.9006C14.4183 17.9006 18 14.3411 18 9.95031C18 5.55947 14.4183 2 10 2C5.58172 2 2 5.55947 2 9.95031C2 14.3411 5.58172 17.9006 10 17.9006Z"
        stroke="#C8C8C8"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 15.6455C14.0703 17.1011 12.0937 18 9.9063 18C5.53807 18 2 14.3978 2 9.95032"
        stroke={fillColor ?? "#00A195"}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSvg>
  );
};

const spinning = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const StyledSvg = styled.svg`
  animation: ${spinning} infinite 1s linear;
`;
